export default function ContactInfo() {
  return (
    <section className="py-10 sm:py-16">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">
        <div className="flex flex-col sm:flex-row gap-10 sm:gap-24 sm:ml-80">

          {/* Email Us */}
          <div className="flex flex-col gap-3 sm:ml-60">
            <h3 className="font-semibold text-black text-lg">Email Us</h3>
            
            <a  href="mailto:info.bluekite@gmail.com"
              className="text-gray-600 hover:text-black transition-colors"
            >
              info.bluekite@gmail.com
            </a>
          </div>

          {/* Connect */}
          <div className="flex flex-col gap-3">
            <h3 className="font-semibold text-black text-lg">Connect</h3>
            <div className="flex flex-col gap-2">
              {[
                { label: "LinkedIn", href: "#" },
                { label: "Twitter(X)", href: "#" },
                { label: "Instagram", href: "#" },
                { label: "TikTok", href: "#" },
              ].map((link) => (
                
                <a  key={link.label}
                  href={link.href}
                  className="text-gray-600 hover:text-black transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Location */}
          <div className="flex flex-col gap-3">
            <h3 className="font-semibold text-black text-lg">Location</h3>
            <div className="flex flex-col gap-1">
              <p className="text-gray-600">Aba, Abia State.</p>
              <p className="text-gray-600">Nigeria</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}